import { render, staticRenderFns } from "./pressure_gauge.vue?vue&type=template&id=06b334cb&"
import script from "./pressure_gauge.vue?vue&type=script&lang=js&"
export * from "./pressure_gauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports